import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { DatetimeWidgetPage } from './datetime-widget.page';
import { TranslateModule } from '@ngx-translate/core';
import { DatePickerModule, DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';

const routes: Routes = [
    {
        path: '',
        component: DatetimeWidgetPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule,
        DatePickerModule,
        DateTimePickerModule
    ],
    declarations: [DatetimeWidgetPage]
})
export class DatetimeWidgetPageModule {}
